import { personasRepositoryInstance } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/instances/personasRepository';
import { personasServices } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/services/personas.service';
import { PatientDeal } from '../../../ts';

export const getPatientMostRecentDealService = async ({ patientId }: { patientId: string }): Promise<PatientDeal> => {
  const patientMostRecentDeal = await personasServices(personasRepositoryInstance).getPatientMostRecentDealById(patientId, 1, 200);
  
  console.log('MOST RECENT CONTACT DEAL ', patientMostRecentDeal)

  if (typeof patientMostRecentDeal === 'string') throw new Error(patientMostRecentDeal);

  return {
    ...patientMostRecentDeal,
  };
};
